import React from 'react';
import SuccessIcon from '../../icons/check-circle.svg';
import { ResultPageLayout } from '../../layouts/ResultPageLayout';
import { ReturnToBookingPortal } from './buttons';
import { BookingCancelledProps } from './types';
import { useTranslation } from 'react-i18next';

export const BookingCancelled = ({ restaurantName, linkTo }: BookingCancelledProps) => {
	const { t } = useTranslation();
	return (
		<ResultPageLayout headerIcon={SuccessIcon} iconAltText={t('titles.successfully_cancelled')}>
			<ResultPageLayout.Title>{t('titles.sorry_to_see_you_go')}</ResultPageLayout.Title>

			<ResultPageLayout.Body>
				<p>
					{t('messages.booking_cancelled_prefix')} <b>{restaurantName}</b> {t('messages.booking_cancelled_suffix')}
				</p>
				<p>{t('messages.cancellation_email_notice')}</p>

				<ResultPageLayout.Footer>
					<ReturnToBookingPortal to={linkTo} />
				</ResultPageLayout.Footer>
			</ResultPageLayout.Body>
		</ResultPageLayout>
	);
};
